import loadFirebase, { getFirebaseApp } from '../firebase';
import { getImpersonationSession } from '../../helpers/impersonation';

let authPromise = null;

const authModule = async () => {
    const firebase = await loadFirebase();
    const auth = getFirebaseApp().auth();
    if (!authPromise) {
        authPromise = getImpersonationSession()
            ? auth.setPersistence(firebase.auth.Auth.Persistence.SESSION).then(() => auth)
            : Promise.resolve(auth);
    }

    return authPromise;
};

export default authModule;
